import { BaseReducer } from '@identic/api';
import { TopographyState, TopographyInitialState, TopographyActions } from './topography.state';

export function TopographyReducer(state: TopographyState = TopographyInitialState, action: any): TopographyState {
  return BaseReducer(state, action, TopographyActions);
}
// console.log(`%cTopographyReducer::ngOnInit`, 'background:yellow');
